import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export default axios.create({
  baseURL: process.env.REACT_APP_PORTAL_API_URL,
  withCredentials: true,
  headers: {
    'X-CSRFToken': cookies.get('csrftoken'),
  },
});
